/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { FormSection } from '@fitinsur/components'

import { Row } from "components/Grid";

import { GeneralSection } from '../../general/index';
import { BrokerRemunerationDeductionSection } from '../index';

function RenderSection({
  disableAll,
  formikProps,
  formikRef,
  idProduct,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
  brokerRemunerationDeductionGroup,
  setBrokerRemunerationDeductionGroup,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
}) {

  return (
    <>
      <Row>
        <GeneralSection.components.Styled.Title>
          Other Deductions
        </GeneralSection.components.Styled.Title>
      </Row>

      {brokerRemunerationDeductionGroup.map((questions, index) => (
        <FormSection
          key={index}
          sectionIndex={index}
          sectionName="BROKER_REMUNERATION_DEDUCTION"
          formikRef={formikRef}
          disableAll={disableAll}
          values={formikProps.values}
          errors={formikProps.errors}
          setFieldValue={formikProps.setFieldValue}
          setFieldError={formikProps.setFieldError}
          questionnaire={questions}
          idOperation={idOperation}
          idOperationParent={idOperationParent}
          idProduct={idProduct}
          extraButtons={() => {
            return GeneralSection.components.RenderSectionAddAndRemoveRowButtons({
              partySectionName: "BROKER_REMUNERATION_DEDUCTION",
              sectionState: brokerRemunerationDeductionGroup,
              setSectionState: setBrokerRemunerationDeductionGroup,
              index,
              questions,
              questionnaireAnswersToDelete,
              setQuestionnaireAnswersToDelete
            });
          }}
          onQuestionChange={(
            question,
            value,
            questionnaireUpdated,
            setQuestionnaireUpdated,
            setFieldValue
          ) =>
            BrokerRemunerationDeductionSection.events.handleQuestionChange({
              question,
              value,
              questionnaireUpdated,
              setQuestionnaireUpdated: (questionnaire) => setBrokerRemunerationDeductionGroup(brokerRemunerationDeductionGroup.map((v, i) => i === index ? questionnaire : v)),
              setFieldValue,
            })
          }
        />
      ))}
    </>
  )
}

const components = {
  RenderSection
}

export { components }